import { Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/Toast';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Listings from './pages/Listings';
import ListingDetail from './pages/ListingDetail';
import MapView from './pages/MapView';
import SavedSearches from './pages/SavedSearches';
import Favorites from './pages/Favorites';
import Login from './pages/Login';
import Register from './pages/Register';
import IdealistaSetup from './pages/IdealistaSetup';
import Leads from './pages/Leads';
import NotFound from './pages/NotFound';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="listings" element={<Listings />} />
          <Route path="listings/:id" element={<ListingDetail />} />
          <Route path="map" element={<MapView />} />
          <Route path="searches" element={<SavedSearches />} />
          <Route path="favorites" element={<Favorites />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="idealista-setup" element={<IdealistaSetup />} />
          <Route path="leads" element={<Leads />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
